"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
class Actions {
    constructor() { }
    static createAccount() {
        return {
            type: 'CreateAccount',
        };
    }
    static deleteAccount(params) {
        return {
            type: 'DeleteAccount',
            params,
        };
    }
    static addKey(params) {
        return {
            type: 'AddKey',
            params,
        };
    }
    static deleteKey(params) {
        return {
            type: 'DeleteKey',
            params,
        };
    }
    static deployContract(params) {
        return {
            type: 'DeployContract',
            params,
        };
    }
    static stake(params) {
        return {
            type: 'Stake',
            params,
        };
    }
    static functionCall(params) {
        return {
            type: 'FunctionCall',
            params,
        };
    }
    static transfer(params) {
        return {
            type: 'Transfer',
            params,
        };
    }
}
exports.Actions = Actions;
//# sourceMappingURL=Actions.js.map